const spaceBetween = ( ...strings: string[]): string => strings.filter(( s ) => !!s ).join( ' ' );

export const StringFormatter = {
  spaceBetween,
};
